export default (state) => state.restricted.message.all_messages;
